import React, { useContext } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import StateInfoField from "./StateInfoField";
import { format, parseISO } from 'date-fns';
import ru from 'date-fns/locale/ru'
import EditRolesModal from "../EditRolesModal";
import RolesBadges from "./RolesBadges";
import EditButton from "../../../../../../../ui/EditButton";
import { getPersonRoles } from "../../../../store/actions";
import SecurityContext from "../../../../../../../SecurityContext";
import ViewPageLayout from "../../../../../../../ui/ViewPageLayout";

const styles = () => ({
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    marginBottom: "24px",
    marginTop: "16px"
  }
});

const formatDate = date =>
    date ? format(parseISO(date), "dd.MM.yy", { locale: ru }) : null;

const formatDateTime = date =>
    date ? format(parseISO(date), "dd.MM.yy HH:mm:ss", { locale: ru }) : null;

const AccountData = ({
  classes,
  disabled,
  systemInfo,
  getPersonRoles,
  personRoles,
  editmode,
  personId
}) => {
  const [editModalOpen, setEditModalOpen] = React.useState(false);

  let securityContext = useContext(SecurityContext);
  let isAdmin = securityContext.hasRole('admin');
  let isStaff = securityContext.hasRole('staff');

  const showEditModal = () => {
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
  };

  React.useEffect(() => {
    getPersonRoles(personId);
  }, [personId]);

  return(
    <ViewPageLayout header="Учётные данные">
      <EditRolesModal
        open={editModalOpen}
        handleClose={closeEditModal}
        personRoles={personRoles}
      />
      {(systemInfo && systemInfo.info) &&
      <div className={classes.block}>
            <StateInfoField field="Статус пользователя:" value={systemInfo.info.sysRegStateName || "-"}/>
            <StateInfoField field="Зарегистрирован:" value={systemInfo.info.sysRegDate ? formatDate(systemInfo.info.sysRegDate) : "-"}/>
            <StateInfoField field="Способ регистрации:" value={systemInfo.info.sysRegModeName || "-"}/>
            <StateInfoField field="Последний вход:" value={systemInfo.info.sysLastLoginDate ? formatDateTime(systemInfo.info.sysLastLoginDate) : "-"}/>
            <StateInfoField field="Open Id:" value={systemInfo.info.sysOpenId || "-"}/>
      </div>
    }

      <Typography className={classes.heading}>
        Роли в системе
        {(isAdmin || isStaff) &&
        <div style={{"marginLeft":16}}>
          <EditButton onClick={showEditModal}/>
        </div>}
      </Typography>
      {(personRoles && personRoles.length > 0) ? <RolesBadges roles={personRoles}/>
            : <Typography variant="caption" color="textSecondary">отсутствуют </Typography>
      }
    </ViewPageLayout>
  )
};

const mapStateToProps = state => ({
  personRoles: state.persons.roles
});

const mapDispatchToProps = dispatch => ({
  getPersonRoles: (id) => dispatch(getPersonRoles(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AccountData));
